export const ACTION_TYPE = {
  LINK: 'LINK',
  KB_LINK: 'KB-LINK',
  CUSTOM: 'CUSTOM',
  OPEN_MODAL_PANEL: 'OPEN_MODAL_PANEL',
  OPEN_COMPONENT_PANEL: 'OPEN_COMPONENT_PANEL',
  OPEN_BIZ_PANEL: 'OPEN_BIZ_PANEL',
  SELECT_TAB: 'SELECT_TAB',
}
